import { isPreviewMode } from '../../app/preview/utils/isPreviewMode';

/**
 * Only the static version of the production deployment is considered a public release.
 */
export function isPublicRelease() {
	return process.env.ENVIRONMENT === 'production' && !isPreviewMode();
}
